var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide bg-cover bg-center",style:(_vm.style)},[(_vm.overlay)?_c('div',{staticClass:"overlay"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }